import { createContext, useCallback, useContext, useState } from 'react';

type UnsentReplies = Record<string, string>;

/** Replies refused because replies were turned off as they were sent, by the comment they answered. */
export const UnsentRepliesContext = createContext<UnsentReplies>({});

export const useUnsentRepliesHere = () => useContext(UnsentRepliesContext);

/**
 * Keeps what a person typed when reading the answers again takes their reply field away. Reopening
 * replies gives them the field back, so a later closing must not bring the old text up again.
 */
export const useUnsentReplies = (areRepliesClosed: boolean) => {
    const [unsentReplies, setUnsentReplies] = useState<UnsentReplies>({});
    const [wereRepliesClosed, setWereRepliesClosed] = useState(areRepliesClosed);

    if (areRepliesClosed !== wereRepliesClosed) {
        setWereRepliesClosed(areRepliesClosed);
        if (!areRepliesClosed) {
            setUnsentReplies({});
        }
    }

    const keepUnsentReply = useCallback((reviewQuestionAnswerId: string, content: string) => {
        setUnsentReplies((current) => ({ ...current, [reviewQuestionAnswerId]: content }));
    }, []);

    return { unsentReplies, keepUnsentReply };
};
